export const RequestDemoButton = () => {
  return (
    <a
      href="https://calendar.app.google/mowuhtsLkA1ri8Rz9"
      css={`
        width: 100%;

        @media (min-width: 960px) {
          width: fit-content;
        }
      `}
      target="_blank"
      rel="noreferrer"
      tabIndex={-1}
    >
      <button
        css={`
          display: flex;
          justify-content: center;
          align-items: center;
          height: 52px;
          padding: 16px 24px;
          width: 100%;
          border: 1px solid #000;
          border-radius: 10px;
          background-color: #fff;
          color: #18181b;
          font-size: 18px;
          line-height: 28px;
          font-weight: 600;
          cursor: pointer;
          transition: opacity 120ms cubic-bezier(0.5, 1, 0.89, 1);

          :hover {
            opacity: 0.9;
          }

          @media (min-width: 960px) {
            width: fit-content;
          }
        `}
      >
        Request a demo
      </button>
    </a>
  );
};
